import React from "react";
import styles from "./FeatureBox.module.scss";

function FeatureBox({ imgSrc, title, subTitle }) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {imgSrc && <img src={imgSrc} alt={title} />}
        <div className={styles.textContainer}>
          <span className={styles.title}>{title}</span>
          <span className={styles.subTitle}>{subTitle}</span>
        </div>
      </div>
    </div>
  );
}

export default FeatureBox;
